import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { ProductCard } from '@/components/ProductCard';
import { ProductGridSkeleton } from '@/components/ProductCardSkeleton';
import { search } from '@/lib/api';
import { Footer } from '@/components/Footer';

const SearchPage = () => {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get('q') || '');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q) { setResults([]); return; }
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const data = await search(q);
        setResults(data.products || []);
        const next = new URLSearchParams(params);
        next.set('q', q);
        setParams(next, { replace: true });
      } finally { setLoading(false); }
    }, 180);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [q]);

  return (
    <div>
      <section className="bb-cloud-bg">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-6">
          <h1 className="font-display text-2xl md:text-3xl font-bold">Search</h1>
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Try “unicorn” or “digit 5”" className="h-12 rounded-xl mt-3 bg-white" data-testid="search-page-input" />
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-4 md:px-6 mt-5">
        {loading ? <ProductGridSkeleton count={6} /> : results.length === 0 ? (
          <div className="py-10 text-center text-sm text-muted-foreground">{q ? 'No matches' : 'Type to search'}</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {results.map((p) => <ProductCard key={p.slug} product={p} />)}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
};

export default SearchPage;
